import { render, staticRenderFns } from "./FormMarksLegalsPg.vue?vue&type=template&id=d3a5c516&scoped=true&"
import script from "./FormMarksLegalsPg.vue?vue&type=script&lang=js&"
export * from "./FormMarksLegalsPg.vue?vue&type=script&lang=js&"
import style0 from "./FormMarksLegalsPg.vue?vue&type=style&index=0&id=d3a5c516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a5c516",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VFileInput,VForm,VRow,VTextarea})
